<template>
   <div class="formCom">
  <div class="form">
    <button class="close" @click="closeModal">
      <CloseIcone></CloseIcone>
    </button>
    <div class="name">
      Edit Customer
      <span class="txt">
        {{ txt }}
      </span>
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        name="first_name"
        placeholder="First Name"
        v-model="first_name"
        v-validate="'required|max:50'"
      />
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        name="last_name"
        placeholder="Last Name"
        v-model="last_name"
        v-validate="'required|max:50'"
      />
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input toLowerCase"
        name="email"
        placeholder="E-mail"
        v-model="email"
        @keyup="changeFeild('email')"
        @change="changeFeild('email')"
        :class="{ invalid: errors.has('email') }"
        v-validate="`required|email|email_exist_other_customer:${currentCus.id}`"
      />
    </div>
    <div class="phone-validate-error" v-if="emailValErr">
      {{verifyEmailTxt}} 
    </div>
    <div class="phone-validate-error" v-else-if="errors.has('email')">
      {{errors.first("email")}} 
    </div>
    <div class="input-wrap">
      <div class="verification">
        <label>
          <input type="checkbox" v-model="emailverifyStatus" /> Mark Email As Verified
        </label>
      </div>
    </div>
    <div class="input-wrap">
      <input
        type="text"
        class="input"
        placeholder="phone"
        v-model="phone"
        name="phone"
        v-validate="'required|min:16|phone_exist'"
        v-mask="'(###) ### - ####'"
        @keyup="changeFeild('phone')"
        @change="changeFeild('phone')"
      />
    </div>
    <div class="phone-validate-error" v-if="errors.has('phone')">
      {{errors.first("phone")}} 
    </div>
    <div class="input-wrap">
      <div class="verification">
        <label>
          <input type="checkbox" v-model="phoneStatus" /> Mark Phone As Verified
        </label>
      </div>
    </div>
    <button class="btn" @click="updateProfile" :disabled="hasErrors">Save</button>
  </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import CloseIcone from "../../../images/shared/cancel";
import CodeNumber from "../../registration/CodeNumber";

export default {
  name: "Personal",
  directives: { mask },
  props : ['currentCus'],
  data() {
    return {
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      oldEmail: null,
      oldPhone: null,
      showCodeEmail: false,
      showCodePhone: false,
      verifyPhoneTxt: "Your phone number is not verified.",
      verifyEmailTxt: "Your email address is not verified.",
      txt: "",
      phoneCode: null,
      emailCode: null,
      emailValErr:false,
      emailverifyStatus:0,
      phoneStatus:0
    };
  },
  computed: {
    // Computed property to determine if there are any errors
    hasErrors() {
      return this.errors.any() || this.emailValErr;
    }
  },
  components: {
    CodeNumber,
    CloseIcone
  },
  watch : {
    currentCus (obj){
      this.first_name = obj.first_name;
      this.last_name = obj.last_name;
      this.email = obj.email;
      this.phone = obj.phone.substring(1);
      if(obj.confirmed_email){
        this.emailverifyStatus = 1
      }
      if(obj.confirmed_phone){
        this.phoneStatus = 1
      }
    }
  },
  methods: {
    ...mapActions(["updateCustomer", "saveNumber"]),
    setPhoneNumber(str) {
      return str.substring(1);
    },
    changeFeild (val){
      if (val === "phone") {
        this.showCodePhone = false;
      } 
      if (val === "email")  {
        this.showCodeEmail = false;
      }
    },
    valError(obj){
       var val_error = obj.error.data.messages.errors;
       var txt ="";
       for (let x in val_error) {
          if(val_error[x].field == "email" && val_error[x].validation == "unique"){
            this.emailValErr = true;
            this.verifyEmailTxt = val_error[x].message;
            return;
          } else if(val_error[x].field == "confirmation_email_code" && val_error[x].validation == "required"){
             this.emailValErr = true;
             this.verifyEmailTxt = val_error[x].message;
          }
        }
    },
    nextStep(obj) {
      const data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.toLocaleLowerCase(),
        phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
        confirmed_email : this.emailverifyStatus,
        confirmed_phone : this.phoneStatus,
        id:this.currentCus.id
      };
      this.updateCustomer(data).then(res => {
        if(res.field == "email" && res.validation == "unique"){
          this.emailValErr = true;
          this.verifyEmailTxt = "This email is already registered.";
          return;
        }  else {
            this.emailValErr = false;
            this.verifyEmailTxt = "";
        }
        const contacts = {
          phone: res.data.data.user.phone,
          mail: res.data.data.user.email
        };
        this.saveNumber(contacts);
        this.txt = "Your Information was updated";
      });
      this.txt = "Your Information was updated.";
    },
    closeModal() {
      this.$emit("closeCusEdit", false);
    },
    updateProfile(data_type){
         const data = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email.toLocaleLowerCase(),
          phone: `1${this.phone.replace(/[\s-()+]/g, "")}`,
          confirmed_email : this.emailverifyStatus,
          confirmed_phone : this.phoneStatus,
          id: this.currentCus.id
        };
        this.updateCustomer(data).then(res => {
          if(res.field == "email" && res.validation == "unique"){
           this.emailValErr = true;
           this.verifyEmailTxt = "This email is already registered.";;
           return;
          } else {
            this.emailValErr = false;
            this.verifyEmailTxt = "";
          }
          const contacts = {
            phone: res.data.data.user.phone,
            mail: res.data.data.user.email
          };
          if((res.data.data.user.email !== this.email) || 
          (res.data.data.user.email  === this.email && res.data.data.user.confirmed_email !== true)){
            this.showCodeEmail = true;    
          } else {
            this.showCodeEmail = false;
          }
          if((res.data.data.user.phone !== `1${this.phone.replace(/[\s-()+]/g, "")}`) || 
          (res.data.data.user.phone === `1${this.phone.replace(/[\s-()+]/g, "")}` && res.data.data.user.confirmed_phone !== true)){
            this.showCodePhone = true;
          } else {
            this.showCodePhone = false;
          }
          
          this.saveNumber(contacts);
          this.txt = "Your Information was updated";
          if(!this.emailValErr) {
            this.$emit("closeCusEdit", false);
          }
        });
    },
    changeModal(val) {
      this.$emit("changeModal", val);
    }
  },
  mounted() {
    console
    this.first_name = this.currentCus.first_name;
    this.last_name = this.currentCus.last_name;
    this.email = this.currentCus.email;
    this.phone = this.currentCus.phone.substring(1);
    if(this.currentCus.confirmed_email){
        this.emailverifyStatus = 1
    }
    if(this.currentCus.confirmed_phone){
      this.phoneStatus = 1
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.input.invalid {
  border: 1px solid $red;
}
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
  background-color: $white;
  max-width: 500px;
  width: 100%;
  position: relative;
}
.input-wrap {
  width: 100%;
  margin: 0 0 15px 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 36px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: $green;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.name {
  color: $blue;
  font-size: 27px;
  margin: 0 0 36px 0;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.txt {
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  color: orange;
  margin: 10px 0;
  text-align: center;
}
.phone-validate-error {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  margin: 10px 0;
  text-align: center;
}
.textError {
  color: $red;
}
.name .txt {
  font-family: TTNormsMedium, sans-serif;
  position: absolute;
  left: 0;
  bottom: -0px;
  color: green;
  font-size: 13px;
  width: 100%;
}
@media (max-width: 1024px) {
  .form {
    margin: 100px 0 0 0;
  }
  .input-wrap {
    border: 1px solid #e4e4e4;
  }
  .name {
    display: flex;
    flex-direction: column;
  }
  .name .txt {
    position: static;
    padding: 10px 0 0 0;
    top: 0;
    left: 0;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 20px;
    max-width: 300px;
  }
  .name {
    font-size: 20px;
    margin: 0px 0 20px 0;
  }
  .input {
    font-size: 13px;
    padding: 10px 15px;
  }
  .btn {
    height: 40px;
    font-size: 15px;
  }
}
.formCom {
  /*background-color: rgba(219, 230, 241, 0.5);*/
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.verification{
 text-align: center;
}
@media (max-width: 1024px) {
  .formCom {
    align-items: flex-start;
  }
}
</style>
